import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	overlayButton: 'js-m-teaser-video__overlay-button',
	overlayArea: 'js-m-teaser-video__overlay',
	buttonClose: 'js-m-teaser-video__close'
};

@createModule('TeaserVideo')
/**
 * TeaserVideo module implementation.
 *
 * @author Ellen Xia
 */
export class TeaserVideo extends TerrificSpec {
	$ctx: JQuery;
	$overlayButton: JQuery;
	$overlayArea: JQuery;
	$buttonClose: JQuery;
	
	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$overlayButton = $(`.${classes.overlayButton}`, this.$ctx);
		this.$overlayArea = $(`.${classes.overlayArea}`, this.$ctx);
		this.$buttonClose = $(`.${classes.buttonClose}`, this.$ctx);

		this.showTeaserVideo();
		this.hideTeaserVideo();
		
		resolve();
	}
	stop() {}

	showTeaserVideo() {
		this.$overlayButton.on('click',
		() => {
			// Show dialog
			this.$ctx.addClass('state-m-teaser-video--visible');
			$('html').addClass('no-scrolling--without-scrollbar');
			// Start playback
			this.startVideoPlayback();
		})
	}
	
	hideTeaserVideo() {
		this.$buttonClose.on('click',
		() => {
			// Stop playback
			this.stopVideoPlayback();
			// Close dialog
			this.$ctx.removeClass('state-m-teaser-video--visible ');
			$('html').removeClass('no-scrolling--without-scrollbar');
		})
	}

	private startVideoPlayback() : void{
		const player = this.getVideoPlayer();
		if (player) player.play();
	}

	private stopVideoPlayback() : void{
		const player = this.getVideoPlayer();
		if (player) player.pause();
	}

	private getVideoPlayer() : any{
		if ((window as any).VideoPlayer === undefined || (window as any).VideoPlayer.Collection === undefined ) {
			return null;
		}

		const componentId = this.$ctx.find("[data-t-name=VideoComponent]").data("t-id");
		if (componentId === undefined || !componentId) {
			return null;
		}

		try {
			const playerId = `a-video__mi-player-${componentId}`;
			return (window as any).VideoPlayer.Collection.getPlayerById(playerId);	
		} catch (error) {
			// The remote library throws an exception when the video is not yet started.
			// This is also the case when the video is lazy-loading, and the user did not click start yet.
			// See: https://doc.movingimage.com/display/JA/VideoPlayer.Collection+Object
			return null;
		}
	}
}
